import {
	ClusterContextMenuResponse,
	MarkerContextMenuResponse,
	VisibleMarkerKeysResponse
} from "@sureview/v2-mapping-saas";
import { MutationTree } from "vuex";
import { getDefaultState } from "./state";
import { MapState, PlotItem } from "./types";

export const mutations: MutationTree<MapState> = {
	/**
	 * @summary Sets the markerContextMenuResponse.
	 * @param {MapState} state The map module state.
	 * @param {MarkerContextMenuResponse | null} markerContextMenuResponse The marker context menu response.
	 */
	setMarkerContextMenuResponse(state: MapState, markerContextMenuResponse: MarkerContextMenuResponse | null): void {
		state.markerContextMenuResponse = markerContextMenuResponse;
	},

	/**
	 * @summary Sets the clusterContextMenuResponse.
	 * @param {MapState} state The map module state.
	 * @param {ClusterContextMenuResponse | null} clusterContextMenuResponse The cluster context menu response.
	 */
	setClusterContextMenuResponse(state: MapState, clusterContextMenuResponse: ClusterContextMenuResponse | null): void {
		state.clusterContextMenuResponse = clusterContextMenuResponse;
	},

	/**
	 * @summary Sets the visibleMarkerKeysResponse.
	 * @param {MapState} state The map module state.
	 * @param {VisibleMarkerKeysResponse | null} visibleMarkerKeysResponse The visible marker keys response.
	 */
	setVisibleMarkerKeysResponse(state: MapState, visibleMarkerKeysResponse: VisibleMarkerKeysResponse | null): void {
		state.visibleMarkerKeysResponse = visibleMarkerKeysResponse;
	},

	/**
	 * @summary Sets the closeInfoWindow.
	 * @param {MapState} state The map module state.
	 * @param {boolean} close Flag indicating whether to close the current info window.
	 */
	setCloseInfoWindow(state: MapState, close: boolean): void {
		state.closeInfoWindow = close;
	},

	/**
	 * @summary Sets the PlotItem.
	 * @param {MapState} state The map module state.
	 * @param {PlotItem} plotItem Plot item to set.
	 */
	setPlotItem(state: MapState, plotItem: PlotItem | null): void {
		state.plotItem = plotItem;
	},

    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};
